import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Measurement } from "@/gql/graphql";

const MEASUREMENT_LABELS: Record<Measurement, string> = {
  [Measurement.Imperial]: "Imperial",
  [Measurement.Metric]: "Metric",
};

export function measurementLabel(
  value?: Measurement | null,
): string | undefined {
  return value ? MEASUREMENT_LABELS[value] : undefined;
}

export function MeasurementInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  const options: {
    [key in Measurement]: {
      label: string;
      value: Measurement;
    };
  } = {
    [Measurement.Imperial]: {
      label: MEASUREMENT_LABELS[Measurement.Imperial],
      value: Measurement.Imperial,
    },
    [Measurement.Metric]: {
      label: MEASUREMENT_LABELS[Measurement.Metric],
      value: Measurement.Metric,
    },
  };

  return (
    <SelectInput
      options={[
        {
          label: "Measurement",
          options: [options[Measurement.Imperial], options[Measurement.Metric]],
        },
      ]}
      {...props}
    />
  );
}
